module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAARCAYAAAA/mJfHAAAAAXNSR0IArs4c6QAAASJJREFUOBHtkj1Ow0AQhWeM4ygVRaAAYqPY1iIUpeAGVs6Ra6QPd+ACnAOQyDESbAsREnoK/2DLwyyILLKDLMst28zMm+89rVYLUHMCy54H5pC4XtegoNUBTfb/YU1e65utvFlg24ehNbx9c93jfXFSl3vJlfd6WcAcbohgGqXF1VaISZzkO4TnoyjOH1gYM3fAdbpbclO5GWq9GSIsAWicsBEJ+9KABP0kzu6lLvcadme/g76YsiDn5/PLk6JIHwlIILuJs34qt08d6HjWerkte5nZf17Mi9MMsgVnuYpA3+jpnrlabZSmuj/DJLIW4uwjyRd8N4fvFnQNzRv4/quyN+w2jmOGln0na0NrOxxpNDLaRSi3Hr5HqRrbdZV/1ibuE53KWrmBnjrQAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/download-file.png
// module id = 1055
// module chunks = 0